import { render, staticRenderFns } from "./VentaNormalComponent.vue?vue&type=template&id=048ba695"
import script from "./VentaNormalComponent.vue?vue&type=script&lang=js"
export * from "./VentaNormalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports